import './index.scss';
import { SearchBar } from 'ii-react-sdk/form_components';
import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import useComponentVisible from '~/hooks/useComponentVisible';
import ClassificationResults from './results';
const ClassificationResultsFilter = ({ categories, descriptors, }) => {
    const { ref, isComponentVisible: isVisible, setIsComponentVisible: setIsVisible, } = useComponentVisible(false);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [filteredDescriptors, setFilteredDescriptors] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    useEffect(() => {
        setFilteredCategories(categories);
    }, [categories]);
    useEffect(() => {
        setFilteredDescriptors(descriptors);
    }, [descriptors]);
    useEffect(() => {
        var _a;
        const pageContentBody = (_a = document.getElementsByClassName('page-content-wrapper')) === null || _a === void 0 ? void 0 : _a[0];
        isVisible
            ? pageContentBody.classList.add('opaque-background')
            : pageContentBody.classList.remove('opaque-background');
    }, [isVisible]);
    const handleSearch = (value) => {
        setSearchValue(value);
        setFilteredCategories(categories.filter(x => x.toLowerCase().includes(value.toLowerCase())));
        setFilteredDescriptors(descriptors.filter(x => x.toLowerCase().includes(value.toLowerCase())));
    };
    const clearSearch = () => {
        setSearchValue('');
        setFilteredCategories(categories);
        setFilteredDescriptors(descriptors);
    };
    const overlayContent = (React.createElement(Popover, { id: 'classification-popover', className: 'classification-popover' },
        React.createElement("div", { className: 'classification-results-filter-ref', ref: ref },
            React.createElement(Popover.Title, null,
                React.createElement("h5", { className: 'text-center', style: { margin: '10px' } },
                    React.createElement("b", null, "FILTER RESULTS"))),
            React.createElement(Popover.Content, { className: 'classification-results-filter-content-container' },
                React.createElement("div", { className: 'action-container' },
                    React.createElement(SearchBar, { id: 'classification-filter-results-search', placeholder: 'Search to filter list below...', value: searchValue, onChange: (e) => handleSearch(e.target.value), clearSearch: clearSearch })),
                React.createElement(ClassificationResults, { filteredCategories: filteredCategories, filteredDescriptors: filteredDescriptors })))));
    return (React.createElement(OverlayTrigger, { placement: 'bottom', overlay: overlayContent, trigger: 'click', show: isVisible },
        React.createElement("span", { className: isVisible ? 'active' : '', onClick: () => setIsVisible(!isVisible) },
            React.createElement("span", { className: 'far fa-sliders-h' }))));
};
export default ClassificationResultsFilter;
